/* global System */
// register component(s) with react habitat

export default { PublicationsGrid: () => System.import('./data') }
